import { booleanCodec, enumCodec, numberCodec, QuerySchema, QuerySetter, useQuerySettings } from '@/hooks/useQueryState'

import {
  DEFAULT_READER_SETTINGS,
  type EpubFlow,
  READER_FONTS,
  type ReaderSettings,
  type ReaderTheme,
} from '../components/reader-settings-types'

const THEMES: readonly ReaderTheme[] = ['light', 'dark', 'sepia']
const FLOWS: readonly EpubFlow[] = ['scrolled', 'paginated', 'continuous']

// 数値の許容範囲は reader-settings-dialog のスライダーと揃える
const EPUB_SETTINGS_SCHEMA: QuerySchema<ReaderSettings> = {
  marginLeft: { param: 'ml', codec: numberCodec(DEFAULT_READER_SETTINGS.marginLeft, { min: 0, max: 100 }) },
  marginRight: { param: 'mr', codec: numberCodec(DEFAULT_READER_SETTINGS.marginRight, { min: 0, max: 100 }) },
  fontSize: { param: 'fs', codec: numberCodec(DEFAULT_READER_SETTINGS.fontSize, { min: 12, max: 32 }) },
  lineHeight: {
    param: 'lh',
    codec: numberCodec(DEFAULT_READER_SETTINGS.lineHeight, { min: 1, max: 3, precision: 1 }),
  },
  fontFamily: { param: 'font', codec: enumCodec(READER_FONTS, DEFAULT_READER_SETTINGS.fontFamily) },
  theme: { param: 'theme', codec: enumCodec(THEMES, DEFAULT_READER_SETTINGS.theme) },
  flow: { param: 'flow', codec: enumCodec(FLOWS, DEFAULT_READER_SETTINGS.flow) },
  swipeEnabled: { param: 'swipe', codec: booleanCodec(DEFAULT_READER_SETTINGS.swipeEnabled) },
}

/**
 * EPUB リーダーの表示設定を URL クエリパラメータで管理するフック。
 *
 * リロードや URL 共有で表示設定（余白 / 文字サイズ / 行間 / フォント / テーマ / フロー / スワイプ）を復元できる。
 */
export const useEpubSettingsQuery = (): [ReaderSettings, QuerySetter<ReaderSettings>] =>
  useQuerySettings(EPUB_SETTINGS_SCHEMA)
